export default __webpack_public_path__ + "754867360e28af8ac07a481aa4ba794b.png";